import React from 'react'
import '../Styles/footer.css'
import LinkSocialMedia from './LinkSocialMedia'
import insta from '../Assets/social-media/insta-icon.svg'
import tiktok from '../Assets/social-media/tiktok-icon.svg'
import x from '../Assets/social-media/x-icon.svg'
import youtube from '../Assets/social-media/youtube-icon.svg'


function FooterComponent() {
  return (
    <footer id='footer' className='padding-50 flex-center flex-column flex__gap-50 larger-checkered-background-dark'>
        <div class="footer-icons flex-center flex__gap-20">
            <LinkSocialMedia 
            id="insta-icon"
            link='https://www.instagram.com/raffaelfragoso/'
            srcImg={insta}
            altImg="Link para o Instagram"
            />
            <LinkSocialMedia 
            link='https://www.tiktok.com/@raffaelfragoso'
            srcImg={tiktok}
            alt="Link para o Tiktok"
            />
            <LinkSocialMedia 
            link='https://x.com/raffaelfragoso'
            srcImg={x}
            alt="Link para o X"
            />
            <LinkSocialMedia 
            link='https://www.youtube.com/@RaffaelFragoso/featured' 
            srcImg={youtube}
            alt="Link para o Youtube"
            />
        </div>
        <p>Copyright 2024 © Raffa Fragoso | Powered By 
        <a href='https://staragency.com.br/' target='__blanck' rel='noopener noreferrer'>
        <span> Star Agency</span>
        </a></p>
    </footer>
  )
}

export default FooterComponent
